import { css, cx } from "@emotion/css"

import { BaseRateDimensions } from "./BaseRateDimensions"
import { Loading } from "components/Loading"
import { RatesTable } from "./RatesTable"
import { fetchBaseRate } from "api/ratecard"
import { useAuthenticated } from "providers/A12n"
import { useI18n } from "providers/I18n"
import { useQuery } from "react-query"

type RatesProps = {
  rateCardId: string
  channelId: string //supplierProductId
  location: string
}

export function Rates(props: RatesProps) {
  const { rateCardId, channelId, location } = props
  const { hasAuthority } = useAuthenticated()
  const { t } = useI18n()

  const allowed = hasAuthority(["AUTH_EDIT_RATE_CARD"])

  const params = new URLSearchParams({
    rateCardId,
    supplierProductId: channelId,
    location,
  }).toString()

  const {
    data: baseRate,
    isSuccess,
    isLoading,
  } = useQuery(["base-rate", params], fetchBaseRate)

  if (isLoading) {
    return (
      <div>
        <Loading />
      </div>
    )
  }

  const config = baseRate?.dimensions
  const baseRateId = baseRate?.id ?? ""
  const noConfig = isSuccess && !config

  if (noConfig) {
    return allowed ? (
      <BaseRateDimensions baseRateId={baseRateId} baseRateParams={params} />
    ) : (
      <p className={cx(styles.wrapper, "HeadlineH6Dark-greyLight")}>
        {t("empty.base.rate")}
      </p>
    )
  }

  return (
    <RatesTable
      baseRateId={baseRateId}
      dimensions={config ?? []}
      data={baseRate?.data ?? []}
    />
  )
}

const styles = {
  wrapper: css`
    display: flex;
    justify-content: center;
    padding: var(--spacing-xxl-5) 0;
  `,
}
